export default {
  state() {
    return {
      requestId: null,
      sendId: null,
      receiverId: null,
      productId: null
    }
  }
}